function isLoopbackHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function lanAwareUrl(configuredUrl) {
  if (!configuredUrl || typeof window === 'undefined') return configuredUrl;
  if (!/^https?:\/\//i.test(configuredUrl)) return configuredUrl;

  try {
    const url = new URL(configuredUrl);
    const pageHost = window.location.hostname;
    if (isLoopbackHost(url.hostname) && !isLoopbackHost(pageHost)) {
      url.hostname = pageHost;
    }
    return url.toString().replace(/\/$/, '');
  } catch (_) {
    return configuredUrl;
  }
}

export function getApiBase() {
  return lanAwareUrl(process.env.VUE_APP_API_URL || 'http://localhost:3000');
}

export function getSocketUrl() {
  return lanAwareUrl(process.env.VUE_APP_SOCKET_URL || 'http://localhost:4000');
}
